/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ul[_ngcontent-%COMP%]{position:relative;list-style:none;margin-left:0;padding-left:1.2em}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{position:absolute;left:0}.pinnedRow[_ngcontent-%COMP%], .rowLine[_ngcontent-%COMP%]{margin:5px;background-color:var(--background-quaternary)!important;color:var(--foreground-quaternary)!important}label.pinnedRow[_ngcontent-%COMP%]{background-color:var(--background-quaternary)!important;color:var(--foreground-quaternary)!important}"];
export { styles as styles };
